<pdq-button
  icon="groups"
  label="Group by... {{ selectedGroups }}"
  variant="ghost"
  [active]="selectedGroups || matTrigger.menuOpen"
  [matMenuTriggerFor]="!disable ? menu : null"
  [disabled]="disable"
  #matTrigger="matMenuTrigger">
</pdq-button>
<mat-menu #menu="matMenu" xPosition="after" class="assign-group-by-menu">
  <div class="menu-wrapper" (click)="$event.stopPropagation()">
    <div class="header">Group orders by:</div>
    @for (group of groupByFields; track group; let i = $index) {
      <div class="select-wrapper">
        <pdq-dropdown
          variant="static"
          [options]="getOptions(group?.value)"
          placeholder="Select a field"
          width="272"
          [defaultOption]="group"
          (onChange)="onOptionSelect($event, i)"></pdq-dropdown>
        <pdq-icon (click)="removeGroup(i)" icon="small_close" size="22" class="close"></pdq-icon>
      </div>
    }
    @if (groupByFields.length < options.length) {
      <div class="add-group" (click)="addGroup()">+ Add another field</div>
    }
  </div>
</mat-menu>
